export default __webpack_public_path__ + "static/media/02__o_3.6ff3ca8b.jpg";